import type { Lang } from '@/src/context/LanguageContext'

const options = {
  priorityOptions: {
    uk: [
      { value: "speed", label: "Швидкість виконання ремонту" },
      { value: "price", label: "Ціна виконання ремонту" },
      { value: "quality", label: "Висока якість виконання робіт" },
    ],
    fr: [
      { value: "speed", label: "Rapidité d'exécution" },
      { value: "price", label: "Prix des travaux" },
      { value: "quality", label: "Haute qualité d'exécution" },
    ],
  },
  premiseTypes: {
    uk: [
      { value: "", label: "Оберіть тип приміщення" },
      { value: "apartment", label: "Квартира" },
      { value: "apartments", label: "Апартаменти" },
      { value: "house", label: "Приватний будинок" },
      { value: "commercial", label: "Комерційне приміщення" },
      { value: "other", label: "Інше" },
    ],
    fr: [
      { value: "", label: "Choisissez le type de local" },
      { value: "apartment", label: "Appartement" },
      { value: "apartments", label: "Appartements (standing)" },
      { value: "house", label: "Maison individuelle" },
      { value: "commercial", label: "Local commercial" },
      { value: "other", label: "Autre" },
    ],
  },
  buildingTypes: {
    uk: [
      { value: "", label: "Оберіть характеристику будівлі" },
      { value: "new", label: "Новобудова" },
      { value: "old", label: "Старий житловий фонд" },
    ],
    fr: [
      { value: "", label: "Choisissez la caractéristique du bâtiment" },
      { value: "new", label: "Construction neuve" },
      { value: "old", label: "Ancien fond de logement" },
    ],
  },
  demolitionOptions: {
    uk: [
      { value: "", label: "Оберіть варіант" },
      { value: "no", label: "Ні" },
      { value: "yes", label: "Так" },
    ],
    fr: [
      { value: "", label: "Choisissez une option" },
      { value: "no", label: "Non" },
      { value: "yes", label: "Oui" },
    ],
  },
  designProjectOptions: {
    uk: [
      { value: "", label: "Оберіть варіант" },
      { value: "yes", label: "Так" },
      { value: "no", label: "Ні" },
      { value: "inProgress", label: "У процесі розробки" },
    ],
    fr: [
      { value: "", label: "Choisissez une option" },
      { value: "yes", label: "Oui" },
      { value: "no", label: "Non" },
      { value: "inProgress", label: "En cours d'élaboration" },
    ],
  },
}

export const getPriorityOptions = (lang: Lang) => options.priorityOptions[lang]
export const getPremiseTypes = (lang: Lang) => options.premiseTypes[lang]
export const getBuildingTypes = (lang: Lang) => options.buildingTypes[lang]
export const getDemolitionOptions = (lang: Lang) => options.demolitionOptions[lang]
export const getDesignProjectOptions = (lang: Lang) => options.designProjectOptions[lang]

// Legacy exports for backwards compatibility (Ukrainian defaults)
export const priorityOptions = options.priorityOptions.uk
export const premiseTypes = options.premiseTypes.uk
export const buildingTypes = options.buildingTypes.uk
export const demolitionOptions = options.demolitionOptions.uk
export const designProjectOptions = options.designProjectOptions.uk
